import { FormErrorFormatterMap } from "@lantern/app/common/forms/";

export const LOGIN_ERROR_MAP: FormErrorFormatterMap = {
  isEmail: () => "Email must be in valid format",
  confirm: () => "Passwords must match",
  complexity: (_, { warning }) => warning,
  reCaptchaResponseRequired: () => "Please complete reCAPTCHA check"
};
